// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l2-1";
export var messageSideRight = "_l2-2";
export var orderLookupBubbleContainer = "_l2-0";
export var submitButton = "_l2-3";